import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../../lib/utils';

export const textareaVariants = cva(
  [
    'flex w-full rounded-md border bg-background px-3 py-2.5 text-sm text-foreground shadow-xs',
    'outline-none transition-colors resize-y',
    'placeholder:text-muted-foreground',
    'focus-visible:ring-2 focus-visible:ring-primary/40',
    'disabled:cursor-not-allowed disabled:opacity-50',
    // Campo com erro (Figma 20080:1334, mesmo padrão do Input): borda destructive +
    // anel de 3px destructive-60 sempre visível. O aria-invalid vem do FormFieldControl.
    'aria-invalid:border-destructive aria-invalid:shadow-none aria-invalid:ring-[3px] aria-invalid:ring-destructive-60',
  ].join(' '),
  {
    variants: {
      variant: {
        default: 'border-input',
        destructive: 'border-destructive shadow-none ring-[3px] ring-destructive-60',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement>, VariantProps<typeof textareaVariants> {}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, ...props }, ref) => (
    <textarea
      ref={ref}
      data-slot="textarea"
      className={cn(textareaVariants({ variant }), className)}
      {...props}
    />
  )
);
Textarea.displayName = 'Textarea';

export { Textarea };
